/**
 * Haptic feedback utilities for mobile devices
 */

/**
 * Check if haptics are available
 */
export function isHapticsAvailable(): boolean {
  return 'vibrate' in navigator;
}

/**
 * Light haptic feedback (selection change)
 */
export function hapticLight(): void {
  if (isHapticsAvailable()) {
    navigator.vibrate(10);
  }
}

/**
 * Medium haptic feedback (button press)
 */
export function hapticMedium(): void {
  if (isHapticsAvailable()) {
    navigator.vibrate(20);
  }
}

/**
 * Heavy haptic feedback (important action)
 */
export function hapticHeavy(): void {
  if (isHapticsAvailable()) {
    navigator.vibrate(40);
  }
}

/**
 * Success haptic feedback (task completed)
 */
export function hapticSuccess(): void {
  if (isHapticsAvailable()) {
    navigator.vibrate([10, 50, 10]);
  }
}

/**
 * Error haptic feedback
 */
export function hapticError(): void {
  if (isHapticsAvailable()) {
    navigator.vibrate([20, 50, 20, 50, 20]);
  }
}

/**
 * Notification haptic feedback
 */
export function hapticNotification(): void {
  if (isHapticsAvailable()) {
    navigator.vibrate([10, 20, 10]);
  }
}

/**
 * Countdown haptic pattern (for rest timer)
 */
export function hapticCountdown(): void {
  if (isHapticsAvailable()) {
    navigator.vibrate(50);
  }
}
